var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.showInFront
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.label !== "",
                  expression: "label !== ''"
                }
              ],
              class: [
                _vm.labelClass,
                {
                  pointer: !_vm.disabled
                }
              ],
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.changeToggle($event)
                }
              }
            },
            [
              _c("font-awesome-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top-center",
                    value: {
                      content: "This " + _vm.label + " has changed.",
                      trigger: "hover click"
                    },
                    expression:
                      "{\n\t\t\t\tcontent: `This ${label} has changed.`,\n\t\t\t\ttrigger:'hover click'\n\t\t\t}",
                    modifiers: { "top-center": true }
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.useDirtyIcon && _vm.isDirty,
                    expression: "useDirtyIcon && isDirty"
                  }
                ],
                staticClass: "text-warning",
                attrs: { icon: "exclamation-circle" }
              }),
              _vm._v(" "),
              _vm._t("start", [_vm._v(_vm._s(_vm.label))])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.showInFront
        ? [
            _c("font-awesome-icon", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top-center",
                  value: {
                    content: "This " + _vm.label + " has changed.",
                    trigger: "hover click"
                  },
                  expression:
                    "{content: `This ${label} has changed.`, trigger:'hover click'}",
                  modifiers: { "top-center": true }
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.useDirtyIcon && _vm.isDirty,
                  expression: "useDirtyIcon && isDirty"
                }
              ],
              staticClass: "text-warning",
              attrs: { icon: "exclamation-circle" }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.toggleClass, _vm.addedToggleClasses] },
        [
          _c("toggle-button", {
            ref: "toggle",
            class: _vm.toggleSwitchClasses,
            attrs: {
              cssColors: true,
              sync: true,
              disabled: _vm.disabled,
              name: _vm.name,
              ariaLabel: _vm.ariaLabel,
              id: _vm.id,
              labels: _vm.labels
            },
            model: {
              value: _vm.toggleValue,
              callback: function($$v) {
                _vm.toggleValue = $$v
              },
              expression: "toggleValue"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.showInFront
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.label !== "",
                  expression: "label !== ''"
                }
              ],
              class: [
                _vm.labelClass,
                {
                  pointer: !_vm.disabled
                },
                _vm.addedLabelClasses
              ],
              on: { click: _vm.changeToggle }
            },
            [
              _vm._t("end", [_vm._v("\n\t\t\t" + _vm._s(_vm.label) + "\n\t\t")])
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }